export enum DateFormatEnum {
  A = 'dd-mm-yyyy',
  B = 'mm-dd-yyyy',
  C = 'yyyy-mm-dd',
}
